import React, {useState} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {EmailInput} from '@interstate/components/EmailInput';
import {Button} from '@interstate/components/Button';
import {Alert} from '@interstate/components/Alert';
import {useHealth} from '../context/HealthContext';
import {apiUrl} from '../lib/api';

export default function UnsubscribeForm(): React.ReactElement {
  const {isDown} = useHealth();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch(apiUrl('/subscribers'), {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include',
        body: JSON.stringify({email})
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Failed to unsubscribe. Please try again.');
      }
    } catch {
      setError('Unable to connect. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-subdued flex justify-center pt-16 pb-16 px-4 font-sans">
      <div className="w-full max-w-lg">

        <RouterLink to="/list" className="ids-link text-sm">
          ← Back to Sub-Processor Registry
        </RouterLink>

        <div className="mt-5 bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="h-1 bg-primary-700" />
          <div className="px-8 py-8">
            {submitted ?
              <div>
                <Alert type="success" title="You've been unsubscribed.">
                  <strong>{email}</strong> has been removed from sub-processor change notifications.
                </Alert>
                <div className="mt-5">
                  <RouterLink to="/list" className="ids-link text-sm">← Return to registry</RouterLink>
                </div>
              </div> :
              <div>
                <h1 className="text-xl font-bold text-gray-900 mb-1">Unsubscribe from Notifications</h1>
                <p className="text-sm text-subdued mb-6">
                  Enter your email address to stop receiving notifications about sub-processor list changes.
                </p>

                {error &&
                  <Alert
                    type="error"
                    sx={{marginBottom: '1rem'}}
                    onCloseClick={() => setError('')}
                  >
                    {error}
                  </Alert>
                }

                <form onSubmit={handleSubmit}>
                  <EmailInput
                    name="unsubscribe-email"
                    label="Email Address"
                    value={email}
                    onChange={e => {
                      setEmail(e.target.value);
                      if (error) {
setError('');
}
                    }}
                    placeholder="you@coxautoinc.com"
                    required
                    sx={{marginBottom: '1.5rem'}}
                  />
                  <div className="flex items-center gap-4">
                    <Button buttonStyle="primary" type="submit" size="medium" disabled={loading || isDown}>
                      {loading ? 'Unsubscribing...' : isDown ? 'Service unavailable' : 'Unsubscribe'}
                    </Button>
                    <RouterLink to="/list" className="ids-link text-sm">Cancel</RouterLink>
                  </div>
                </form>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
